import { useEffect, useState } from 'preact/hooks';
import { activeCard, currentModel, isFreeModel, modelLabel, providerReady, settings, ui, updateUi } from '../state/store';
import { renameCard } from '../state/actions';
import { providerMeta } from '../ai/catalog';
import { CueLogo, IconMenu, IconSettings } from './Icons';

function TitleEditor() {
  const card = activeCard.value;
  const [draft, setDraft] = useState(card?.title ?? '');
  useEffect(() => setDraft(card?.title ?? ''), [card?.id, card?.title]);
  if (!card) return null;
  const commit = () => {
    if (draft.trim() && draft.trim() !== card.title) renameCard(draft);
    else setDraft(card.title);
  };
  return (
    <input
      class="card-title-input"
      type="text"
      value={draft}
      aria-label="Card title"
      spellcheck={false}
      onInput={(e) => setDraft((e.target as HTMLInputElement).value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        if (e.key === 'Escape') {
          setDraft(card.title);
          (e.target as HTMLInputElement).blur();
        }
      }}
    />
  );
}

export function TopBar() {
  const meta = providerMeta(settings.value.provider);
  const ready = providerReady.value;
  const sidebarOpen = ui.value.sidebarOpen;
  const free = isFreeModel(currentModel.value);

  return (
    <header class="topbar">
      <button
        type="button"
        class="icon-button"
        title={sidebarOpen ? 'Hide cards (Ctrl+B)' : 'Show cards (Ctrl+B)'}
        aria-label="Toggle the card list"
        aria-expanded={sidebarOpen}
        onClick={() => updateUi({ sidebarOpen: !sidebarOpen })}
      >
        <IconMenu />
      </button>
      <a class="brand" href="./" aria-label="Cue home">
        <CueLogo />
        <span>Cue</span>
      </a>
      <TitleEditor />
      <div class="spacer" />
      <button type="button" class={`model-badge${ready ? '' : ' warn'}`} title="Change the provider or model" onClick={() => updateUi({ settingsOpen: true })}>
        <span class="provider">
          {meta.label}
          {free && ready && <span class="free-tag">Free</span>}
        </span>
        <span class="model">{ready ? modelLabel(settings.value.provider, currentModel.value) : 'Choose a model'}</span>
      </button>
      <button type="button" class="icon-button" title="Settings (Ctrl+,)" aria-label="Settings" onClick={() => updateUi({ settingsOpen: true })}>
        <IconSettings />
      </button>
    </header>
  );
}
